export default __webpack_public_path__ + "static/media/horizontalOrientation.ce8279dc.png";